module.exports = __webpack_public_path__ + "img/di1.3a535e86.png";